import { getConfig } from '../../utils/config';

const configFont = getConfig().theme.font;
const baseFontFamily = `'${configFont.family}', 'Inter', sans-serif`;

export const typography = {
  fontFamily: {
    base: baseFontFamily,
    heading: baseFontFamily
  },
  fontSize: {
    xs: "0.75rem",
    sm: "0.875rem",
    md: "1rem",
    lg: "1.125rem",
    xl: "1.375rem",
    xxl: "2rem"
  },
  fontWeight: {
    regular: 400,
    medium: 500,
    bold: 700
  },
  lineHeight: {
    tight: "1.2",
    normal: "1.5",
    relaxed: "1.875"
  }
};



// WEBPACK FOOTER //
// ./src/design-system/theme/typography.js